
	import { Component, Vue } from 'vue-property-decorator';
	@Component({
		components: {}
	})
	export default class GetStartedView extends Vue {
		private classes: any;

		public newSession() {
			this.$emit('newView', 'GetStartedView');
		}

		public patientRecall() {
			this.$emit('newView', 'PatientRecall');
		}
	}
